<app-card
  title="{{'admin.solution.template.step' | translate}} {{Index + 1}}"
  [advancedButtons]="specialButtons"
  [advanceButton] = "true"
  (outputButtonAdvance)="callFunction($event)"
>
  <div class="row align-items-center" *ngIf="solution.solutionSteps[Index]">
    <div class="col-sm-1">
      {{'global.action' | translate}}
    </div>
    <div class="col-sm-7">
      <ng-select [items]="actionTypes" bindValue="id" bindLabel="label"
                 [(ngModel)]="solution.solutionSteps[Index].actionType" (change)="actionTypeChange()"></ng-select>
    </div>
    <div class="col-sm-1" *ngIf="actionType && actionType.hasNextStepField">
      {{'doctrine.solution.next_step' | translate}}
    </div>
    <div class="col-sm-3" *ngIf="actionType && actionType.hasNextStepField">
      <ng-select [items]="nextSteps" bindValue="value" bindLabel="label" [(ngModel)]="solution.solutionSteps[Index].nextStep"
                 (change)="solutionService.solution.next(solution)"></ng-select>
    </div>
  </div>
  <div [ngSwitch]="actionType.name"
       *ngIf="actionType && ['text','email','confirmation','form','change_status'].includes(actionType.name)" class="m-t-20">
    <app-solution-action-text *ngSwitchCase="'text'" [Index]="Index"></app-solution-action-text>
    <app-solution-action-email *ngSwitchCase="'email'" [Index]="Index"></app-solution-action-email>
    <app-solution-action-confirmation *ngSwitchCase="'confirmation'" [Index]="Index"></app-solution-action-confirmation>
    <app-solution-action-form *ngSwitchCase="'form'" [Index]="Index"></app-solution-action-form>
    <app-solution-action-change-status *ngSwitchCase="'change_status'" [Index]="Index" [statusRequired]="true"></app-solution-action-change-status>
  </div>
</app-card>
